import React from 'react';
import { ThemeProvider } from 'styled-components';

import ResourceWorkflow from '../ExternalReferenceWorkflow';

// Theme
import theme from '../../../../theme';

const IntReferenceWorkflow = (props) => (
    <ThemeProvider theme={theme}>
        <ResourceWorkflow {...props} />
    </ThemeProvider>
);

export default IntReferenceWorkflow;
